import nodeCrypto from 'node:crypto';
;
function getCrypto() {
    if (typeof window !== 'undefined') {
        return window.crypto;
    }
    return nodeCrypto.webcrypto;
}
function getHexTime() {
    return Math.round(new Date().getTime() / 1000).toString(16);
}
function getEpochTime() {
    return new Date().getTime() / 1000;
}
function getHexId(length) {
    const bytes = new Uint8Array(length);
    getCrypto().getRandomValues(bytes);
    let hexString = '';
    for (let i = 0; i < bytes.length; i++) {
        hexString += bytes[i].toString(16);
    }
    return hexString.substring(0, length);
}
function getTraceHeader(segment) {
    return `Root=${segment.traceId};Parent=${segment.id};Sampled=1`;
}
export function getTraceId() {
    const trace = {
        traceId: `1-${getHexTime()}-${getHexId(24)}`,
        id: getHexId(16),
        startTime: getEpochTime(),
    };
    return getTraceHeader(trace);
}
